import InternalLinks from './internal-links';
import useLinkBlocksAsInternalLinks from './use-link-blocks-as-internal-links';
import { LinkBlockList } from '../@types/schema';

export default function LinkBlocksContainer({ linkBlocks }: { linkBlocks?: LinkBlockList }) {
  const internalLinkBlocks = useLinkBlocksAsInternalLinks(linkBlocks);
  if (!internalLinkBlocks.length) return null;

  return (
    <div className="container-xl my-8">
      {internalLinkBlocks.map((linkBlock) => (
        <InternalLinks
          internalLinks={linkBlock.internalLinks}
          key={linkBlock.title}
          title={linkBlock.title}
        />
      ))}
    </div>
  );
}
